import { render, staticRenderFns } from "./CommunicationReasonChart.vue?vue&type=template&id=239fa1ca&scoped=true"
import script from "./CommunicationReasonChart.vue?vue&type=script&lang=js"
export * from "./CommunicationReasonChart.vue?vue&type=script&lang=js"
import style0 from "./CommunicationReasonChart.vue?vue&type=style&index=0&id=239fa1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239fa1ca",
  null
  
)

export default component.exports